import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { get } from 'lodash'

import PayWithCreditCardForm from './PayWithCreditCardForm'
import { payBill } from 'features/Billing/Billing.actions'

const formName = 'payWithCreditCard'

const stateToProps = ({ form }) => {
  return {
    formData: get(form, [formName, 'values'], {}),
    initialValues: {
      useAsDefault: true,
      confirm: false,
    },
  }
}

const dispatchToProps = {
  payBill,
}

export default connect(
  stateToProps,
  dispatchToProps
)(reduxForm({ form: formName })(PayWithCreditCardForm))



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/PayWithCreditCardForm/PayWithCreditCardForm.container.js